export default __webpack_public_path__ + "static/media/ppi-one-pack-logo.e043a701.svg";